import { ApiResponse } from '@marketplace-web/shared/api-client'

import { api } from './api'

export const modifyItemVisibility = (itemId: number, isHidden: boolean) =>
  api.put<ApiResponse>(`/items/${itemId}/is_hidden`, {
    is_hidden: isHidden,
  })
